export const ThumbnailListName = {
  Incomplete: "incomplete",
  Required: "required",
  Recommended: "recommended",
  FormsAndTests: "formsAndTests",
  AmbassadorsBusinessCards: "ambassadorsBusinessCards",
  Competences: "competences"
};
